module.exports = __webpack_public_path__ + "assets/img/ftb_lineup_top_arrow.webp?23401c0d884a423f13f7ad0e5ceaaaea";